module.exports = __webpack_public_path__ + "img/checklist.7cb37bd3.svg";